<div mat-dialog-title class="!font-medium">{{ params.value.id ? '修改' : '新增' }}</div>
<mat-dialog-content>
  <form [formGroup]="params" class="text-sm" (submit)="saveEvent()" ngNativeValidate>
      <div class="mb-5">
          <label for="title">標題 :</label>
          <input id="title" type="text" name="title" class="form-input" placeholder="Enter Event Title" formControlName="title" required />
          <div class="mt-2 text-danger" id="titleErr"></div>
      </div>

      <div class="mb-5">
          <label for="dateStart">從 :</label>
          <input
              id="dateStart"
              type="datetime-local"
              name="start"
              class="form-input"
              placeholder="Event Start Date"
              formControlName="start"
              [min]="minStartDate"
              (change)="startDateChange($event)"
              required
          />
          <div class="mt-2 text-danger" id="startDateErr"></div>
      </div>
      <div class="mb-5">
          <label for="dateEnd">到 :</label>
          <input
              id="dateEnd"
              type="datetime-local"
              name="end"
              class="form-input"
              placeholder="Event End Date"
              formControlName="end"
              [min]="minEndDate"
              required
          />
          <div class="mt-2 text-danger" id="endDateErr"></div>
      </div>
      <div class="mb-5">
          <label for="description">說明 :</label>
          <textarea
              id="description"
              name="description"
              class="form-textarea min-h-[130px]"
              placeholder="Enter Event Description"
              formControlName="description"
          ></textarea>
      </div>
      <div class="mb-5">
          <label>標籤:</label>
          <div class="mt-3">
              <label class="inline-flex cursor-pointer ltr:mr-3 rtl:ml-3">
                  <input type="radio" class="form-radio" name="badge" value="primary" formControlName="type" name="type" />
                  <span class="ltr:pl-2 rtl:pr-2">工作</span>
              </label>
              <label class="inline-flex cursor-pointer ltr:mr-3 rtl:ml-3">
                  <input type="radio" class="form-radio text-info" name="badge" value="info" formControlName="type" name="type" />
                  <span class="ltr:pl-2 rtl:pr-2">旅遊</span>
              </label>
              <label class="inline-flex cursor-pointer ltr:mr-3 rtl:ml-3">
                  <input type="radio" class="form-radio text-success" name="badge" value="success" formControlName="type" name="type" />
                  <span class="ltr:pl-2 rtl:pr-2">個人</span>
              </label>
              <label class="inline-flex cursor-pointer">
                  <input type="radio" class="form-radio text-danger" name="badge" value="danger" formControlName="type" name="type" />
                  <span class="ltr:pl-2 rtl:pr-2">重要</span>
              </label>
          </div>
      </div>
      <!-- <div class="mt-8 flex items-center justify-end">
          <button type="submit" class="btn btn-primary ltr:ml-4 rtl:mr-4">{{ params.value.id ? '確定更新' : '確定新增' }}</button>
          <button type="button" class="btn btn-outline-danger" (click)="onNoClick(false)">取消</button>
      </div> -->
      <mat-dialog-actions>
        <button type="submit" class="btn-primary ml-4" [mat-dialog-close]="true" (click)="onNoClick(true)">{{ params.value.id ? '確定更新' : '確定新增' }}</button>
        <button type="button" class="btn-outline-danger" [mat-dialog-close]="false" (click)="onNoClick(false)">取消</button>
      </mat-dialog-actions>
    </form>
  </mat-dialog-content>
<!-- <ng-template #modalHeader>
  <div class="!font-medium">{{ params.value.id ? 'Edit Event' : 'Add Event' }}</div>
</ng-template>
<ng-template #modalBody>
  <form [formGroup]="params" class="text-sm" (submit)="saveEvent()" ngNativeValidate>
      <div class="mb-5">
          <label for="title">Event Title :</label>
          <input id="title" type="text" name="title" class="form-input" placeholder="Enter Event Title" formControlName="title" required />
          <div class="mt-2 text-danger" id="titleErr"></div>
      </div>

      <div class="mb-5">
          <label for="dateStart">From :</label>
          <input
              id="dateStart"
              type="datetime-local"
              name="start"
              class="form-input"
              placeholder="Event Start Date"
              formControlName="start"
              [min]="minStartDate"
              (change)="startDateChange($event)"
              required
          />
          <div class="mt-2 text-danger" id="startDateErr"></div>
      </div>
      <div class="mb-5">
          <label for="dateEnd">To :</label>
          <input
              id="dateEnd"
              type="datetime-local"
              name="end"
              class="form-input"
              placeholder="Event End Date"
              formControlName="end"
              [min]="minEndDate"
              required
          />
          <div class="mt-2 text-danger" id="endDateErr"></div>
      </div>
      <div class="mb-5">
          <label for="description">Event Description :</label>
          <textarea
              id="description"
              name="description"
              class="form-textarea min-h-[130px]"
              placeholder="Enter Event Description"
              formControlName="description"
          ></textarea>
      </div>
      <div class="mb-5">
          <label>Badge:</label>
          <div class="mt-3">
              <label class="inline-flex cursor-pointer ltr:mr-3 rtl:ml-3">
                  <input type="radio" class="form-radio" name="badge" value="primary" formControlName="type" name="type" />
                  <span class="ltr:pl-2 rtl:pr-2">Work</span>
              </label>
              <label class="inline-flex cursor-pointer ltr:mr-3 rtl:ml-3">
                  <input type="radio" class="form-radio text-info" name="badge" value="info" formControlName="type" name="type" />
                  <span class="ltr:pl-2 rtl:pr-2">Travel</span>
              </label>
              <label class="inline-flex cursor-pointer ltr:mr-3 rtl:ml-3">
                  <input type="radio" class="form-radio text-success" name="badge" value="success" formControlName="type" name="type" />
                  <span class="ltr:pl-2 rtl:pr-2">Personal</span>
              </label>
              <label class="inline-flex cursor-pointer">
                  <input type="radio" class="form-radio text-danger" name="badge" value="danger" formControlName="type" name="type" />
                  <span class="ltr:pl-2 rtl:pr-2">Important</span>
              </label>
          </div>
      </div>
      <div class="mt-8 flex items-center justify-end">
          <button type="button" class="btn btn-outline-danger" (click)="onNoClick(false)">Cancel</button>
          <button type="submit" class="btn btn-primary ltr:ml-4 rtl:mr-4">{{ params.value.id ? 'Update Event' : 'Create Event' }}</button>
      </div>
  </form>
</ng-template> -->
